import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import enterpriseDesBackground from "../../assets/images/intelligence-solution/enterprise-des-backgroundV2.png";
import CustomBreadcrumb from "../../components/customBreadcrumb/CustomBreadcrumb";
import IntelligenceSolutionItemCard from "../../components/intelligenceSolutionItemCard/IntelligenceSolutionItemCard";
import MainLoader from "../../components/loading/MainLoader";
import { IIntelligenceSolutionBusinessPageItem } from "../../interfaces/IntelligenceSolutionBusinessPageItem";
import { ILandingPageDescriptionItem } from "../../interfaces/LandingPageDescriptionItem";
import {
  getBusinessLandingPageContent,
  getBusinessLandingPageDescription,
  getSmeBusinessLandingDescription,
  getSmeBusinessPageContent,
} from "../../store/actions/intelligenceSolution.action";
import { IRootState } from "../../store/configureStore";

const Enterprise = () => {
  const params = useParams();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const {
    businessLandingDescription,
    businessPageContent,
    smeBusinessLandingDescription,
    smeBusinessPageContent,
    isLoading,
  } = useSelector(
    ({ intelligenceSolution }: IRootState) => intelligenceSolution
  );

  const [pageDescription, setPageDescription] =
    useState<ILandingPageDescriptionItem>();
  const [pageContent, setPageContent] =
    useState<IIntelligenceSolutionBusinessPageItem[]>();

  useEffect(() => {
    dispatch(getBusinessLandingPageDescription());
    dispatch(getSmeBusinessLandingDescription());
    dispatch(getSmeBusinessPageContent());
    dispatch(getBusinessLandingPageContent());
  }, [dispatch]);

  useEffect(() => {
    if (
      params.type === "enterprise" &&
      businessLandingDescription.length > 0 &&
      businessPageContent
    ) {
      setPageDescription(businessLandingDescription[0]);
      setPageContent(businessPageContent);
    } else if (
      params.type === "sme" &&
      smeBusinessLandingDescription.length > 0 &&
      smeBusinessPageContent
    ) {
      const description: ILandingPageDescriptionItem = {
        ...smeBusinessLandingDescription[0],
        field_landing_page_content_export:
          smeBusinessLandingDescription[0].field_landing_page_content_export.replace(
            "col-md-offset-3 col-md-6",
            ""
          ),
      };
      setPageDescription(description);
      setPageContent(smeBusinessPageContent);
    } else if (params.type === "globalBusiness") {
      window.open(
        "https://www.xyntac.com/global-presence",
        "_blank",
        "noopener,noreferrer"
      );
      navigate(-1);
    }
  }, [
    params,
    businessPageContent,
    smeBusinessPageContent,
    businessLandingDescription,
    smeBusinessLandingDescription,
    navigate,
  ]);

  const getTitle = (type: string | undefined) => {
    if (type === "enterprise") {
      return "Enterprise";
    } else if (type === "sme") {
      return "SME";
    } else {
      return "";
    }
  };

  return (
    <div className="page-container">
      <MainLoader show={isLoading} />
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          {
            path: "/intelligenceSolution/" + params.type,
            title: getTitle(params.type),
          },
        ]}
      />
      <Row className="p-3">
        <Col
          style={{
            backgroundImage: `url(${enterpriseDesBackground})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            borderRadius: "20px",
            color: "white",
          }}
          className="poppins-regular"
        >
          <div
            className="px-2 py-3"
            dangerouslySetInnerHTML={{
              __html: pageDescription?.field_landing_page_content_export || "",
            }}
          />
        </Col>
      </Row>
      <Row>
        {pageContent?.map((item, index) => (
          <IntelligenceSolutionItemCard key={index} item={item} />
        ))}
      </Row>
    </div>
  );
};

export default Enterprise;
